import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import SelectDropdown from "../Components/Dropdowns/SelectDropdown";
import {wrapValueInOptionStructure} from "../../utils/maybeAddLabelToOptions";

export const PI_ENGINE_SNAPSHOT_VERSIONS_QUERY = '{ nucleusPiEngineSnapshotPeriods(channels: ["prop"]) { period } }';

export const mapPiEngineSnapshotVersionsToOptions = (data) => {
    const versions = data?.nucleusPiEngineSnapshotPeriods?.map((entry) => entry.period) || [];
    return _.orderBy(versions, [], ['desc']).map((version) => wrapValueInOptionStructure(version));
};

const PiEngineSnapshotVersionSelect = ({options, selectedVersion, setSelectedVersion}) => (
    <div id={'pi_engine_snapshot_version_dropdown_div'} className={"custom-run-selections-row"}>
        <SelectDropdown
            id={"pi_engine_snapshot_version_dropdown"}
            dataTestId={"pi_engine_snapshot_version_dropdown"}
            inputLabel={"PI Engine Snapshot Period Override"}
            selectValue={selectedVersion}
            options={options}
            isClearable={true}
            onChange={(option) => setSelectedVersion(option?.value)}
        />
    </div>
);

PiEngineSnapshotVersionSelect.propTypes = {
    options: PropTypes.array,
    selectedVersion: PropTypes.string,
    setSelectedVersion: PropTypes.func.isRequired
};

export default PiEngineSnapshotVersionSelect;
